import { createFileRoute } from '@tanstack/react-router';
import { SmsComposer } from '@/components/sms/SmsComposer';

import { Box } from '@mui/material';

export const Route = createFileRoute(
  '/_authed/dashboard/o/$orgId/c/$clientId/sms/$smsMessageId',
)({
  component: SmsComposerPage,
});

function SmsComposerPage() {
  const { orgId, clientId, smsMessageId } = Route.useParams();

  return (
    <Box sx={{ flex: 1, minHeight: 0, p: { xs: 2, md: 3 }, overflow: 'auto' }}>
      <Box sx={{ maxWidth: 1100, mx: 'auto' }}>
        <SmsComposer orgId={orgId} clientId={clientId} smsMessageId={smsMessageId} />
      </Box>
    </Box>
  );
}
